import React from "react";

const sayalee_khedekar = () => {
  return (
    <div>
      <h1>Sayalee Khedekar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        8+ cgpa and online aptitude test
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The process included an online aptitude test from anywhere on 6th August
        followed by a pre-placement talk, shortlisting of candidates, and then
        technical and HR interviews all on 8th August .{" "}
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        10 aptitude , 2 coding , 3 sql
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        19 for technical interviews
        <br />
        9-11 for hr round
        <br />6 were finally selected{" "}
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The aptitude test was conducted two days before the pre-placement talk,
        and the list of shortlisted students was released right after the talk.
        Since I thought my aptitude test went well, I had begun preparing for
        the interview in advance by going through previous year CSI diaries of
        selected candidates, which proved helpful as a few questions were
        repeated from last year. Also revised theory and my resume related
        questions.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        Two rounds - Technical Interview and HR
        <br />
        Technical Interview -<br />
        He asked me to explain one of my projects, so I described it in detail
        with the help of ER diagrams and OOPs concepts .He covered React
        concepts like Context Provider, Redux, and Props, along with questions
        on REST APIs such as the differences between GET, PUT, and POST methods.
        He also asked a few Git-related questions, including one on the git
        merge command. And I also explained about my internship, the company and
        the work I did. He had a set of questions(booklet) to ask questions
        from/ just to refer. The interview lasted for about an hour.
        <br />
        HR round-
        <br />
        My entire journey right from 11th 12th to my 3rd year, asking about my
        academic and personal growth throughout, was covered .Few common HR
        questions were also included, such as my strengths and weaknesses, what
        I would change if I could rewind time and why. Who is my favorite
        professor ,what rating would he give me out of ten? Questions related to
        my extracurricular activities and hobbies were also asked.{" "}
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Most of the questions were focused on my project, especially technical
        ones related to OOPs, DBMS, React and backend APIs . It’s important to
        explain your project in a detailed, technical way covering why you chose
        specific technologies and how the overall flow of your project works. No
        questions were asked on OS, CN.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Striver A2Z sheet
        <br />
        Love babbar one shots on OS and DBMS
        <br />
        CN - gate smasher playlist
        <br />
        Neetcode 150
        <br />
        Gfg - react / spring boot / java theory
        <br />
        Last minute notes gfg
        <br />
        Aditya Verma - dynamic programming{" "}
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Keep solving questions and try to maintain your LeetCode streak. It
        really helps because even when you don’t feel motivated, it becomes a
        habit. Try to solve questions from different topics like dynamic
        programming, stack, queue, two pointer . Initially to get an idea of the
        topic look at the YouTube videos then try to solve the same topic
        questions. Also revise the questions that you solved not the solution
        but the technique to solve that problem.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In the HR round, questions were asked about my extracurricular
        activities and hobbies. Do include it in your resume.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Focus on OOPs, DSA and DBMS, and try to answer technical questions using
        your projects or internship as examples. In the HR round, keep the
        company’s values in mind, and don’t forget to ask questions at the end
        of the interview.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Start preparing as early as possible, practice DSA regularly. Make notes
        of theory subjects and keep revising them. Build good, problem-solving,
        and creative projects. Keep your calm in the interview.
      </p>

      <p>Don't give up ! </p>

      <p>
        This process does test your patience and your endurance. Don't lose hope
        ,don't think too much, just give your best. Your efforts will never go
        to waste.
      </p>

      <p>
        <strong>Contact Info </strong>
      </p>

      <p>
        <strong>Email :</strong> <a href="mailto:khedekarsn23.comp@coeptech.ac.in">khedekarsn23.comp@coeptech.ac.in</a>
      </p>

      <hr />
    </div>
  );
};

export default sayalee_khedekar;
